<template>
    <div v-on:keyup.esc="$root.$emit('CLOSERESTOREDIALOG')" class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl" v-cloak>

        <DialogTitle :title="$t('MS Exchange Restore')" :defaultTitle="$t('MS Exchange restore')" :subTitle="$t('MS Exchange Backups')" @closeDialog="$root.$emit('CLOSERESTOREDIALOG')" />

        <!---------------------SERVICE ACCOUNT DELLA SORGENTE------------------------------------------------->
        <div v-if="step == STEP_SELECTBACKUPCOPY" class="dialog-content">

            <div v-if="isManual" class="row h6 text-bold m-4">
                <div class="cell-12">{{ $t("Choose source type") }}</div>
            </div>

            <div v-if="isManual" class="form-group">
                <ul data-role="listview" data-view="icons" data-select-node="true" data-selectable="false">
                    <!--Le destinazioni del backup diventano le sorgenti del restore-->
                    <li v-for="sourceType in $ONEServiceTypeInfo[restore.type].backupDestinationTypes" @click="setSourceType(sourceType)" :data-icon="$ONEServiceTypeInfo[sourceType].icon" :data-caption="$ONEServiceTypeInfo[sourceType].name" :key="sourceType" />
                </ul>
            </div>

            <!------------------------------SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->
            <!--Questa pagina deve implementare il metodo "sendSATestResult"-->
            <SARepoSelect v-if="![-1, $ONEServiceType.FileFolder].includes(restore.source_type)" :type=restore.source_type :idSA='restore.source.id_service_account' :idRepo="-2" @sendSATestResult="sendSATestResult" />

            <!-------------------SCELTA PERCORSO CARTELLA COPIA BACKUP----------------------------------------------->
            <SelectedResourcesLayout v-if="isManual" :list="sourceData.selectedNodes" :singleItem="true" :canCancel="false" buttonText="Select the folder of a backup copy" :type="restore.sourceType" :isDisabled="restore.source_type != $ONEServiceType.FileFolder && sourceData.client == null" :heightPercentage="30" @clickFunction="toggleFileSystemSidebar('CHOOSEBACKUPCOPY')" />

        </div>

        <!--INFORMAZIONI INIZIALI SUL RESTORE-->
        <div v-if="step == STEP_SELECTRESTOREOPTIONS" class="dialog-content">

            <!-----------------------------RESTORETYPE: COSA SI VUOLE RECUPERARE?--------------------------------->
            <div class="form-group">
                <h6 class="text-bold">{{ $t("What is to be recovered?") }}:</h6>
                <select class="select w-100" v-model="restore.restoreType">
                    <option :value="1">{{ $t("Recreate full copy from backup") }}</option>
                    <option :value="2">{{ $t("Recreate a specific copy from backup") }}</option>
                </select>
            </div>

            <!-------------------RESTORE DA UN BACKUP - SCELTA DELLA DATA DALLA QUALE ESEGUIRE IL RESTORE----------------------------->
            <div class="form-group">

                <h6 class="text-bold mb-3">{{ $t("Select a copy") }}</h6>
                <div class="overflow" v-if="fileConfig != null && fileConfig.iterations != null">
                    <div v-for="iteration in fileConfig.iterations" :key="iteration.index" class="d-flex mb-4">
                        <input name="iter" type='radio' data-role='radio' class="mr-5" @click="onIterationChanged(iteration)">
                        <div class="pr-4">
                            <div class="d-flex flex-justify-between w-100 pr-3">
                                <div>
                                    <span class='badge inline tertiary'>
                                        {{ $ONEServiceTypeInfo[iteration.sourceType].name }} </span>
                                    <span class="mif-arrow-right mx-1" />
                                    <span class='badge inline tertiary'>
                                        {{ $ONEServiceTypeInfo[iteration.destinationType].name }} </span>
                                </div>

                                <div class="text-bold"><label class="mr-2">{{ $t("Copy number")
                                        }}:</label>{{ (iteration.index + 1) + " / " + (iteration.nCopies + 1) }}</div>
                            </div>
                            <div>
                                <small><b>{{ $t("Backup folder") }} : </b> {{ iteration.iterationFolder }}</small>
                            </div>
                            <small class="text-bold"><label class="mr-2">{{ $t("Start date")
                                    }}:</label>{{ iteration.lastStart | utcAsLocal | moment("LLLL")
                                }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="step == STEP_OPTIONS" class="dialog-content">
            <h6 class="form-group text-bold">{{ $t("Restore Options") }}</h6>
            <!--FILTRI EMAIL-->
            <div class="form-group d-flex row">
                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeInbox" checked />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Inbox') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeSentItems" checked />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Sent Items') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeDrafts" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Drafts') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeOutbox" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Outbox') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeDeletedItems" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Deleted Items') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeJunkeMails" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Junke Mails') }}</span>
                    </label>
                </p>

                <p class="w-50" v-if="!isExchangeRulesActive()">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeArchive" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Archive') }}</span>
                    </label>
                </p>

                <p class="w-50" v-if="!isExchangeRulesActive()">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includePublicFolders" />
                    <label>
                        <span class='mif-email mr-2'></span>
                        <span>{{ $t('Include Public Folders') }}</span>
                    </label>
                </p>
                <!--FILTRO ALTRI ELEMENTI-->


                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeCalendar" />
                    <label>
                        <span class='mif-calendar mr-2'></span>
                        <span>{{ $t('Include Calendar') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeContacts" />
                    <label>
                        <span class='mif-contacts-dialer mr-2'></span>
                        <span>{{ $t('Include Contacts') }}</span>
                    </label>
                </p>

                <p class="w-50">
                    <input data-role="checkbox" type="checkbox" v-model="restore.source_options.includeTasks" />
                    <label>
                        <span class='mif-add_task mr-2'></span>
                        <span>{{ $t('Include Tasks') }}</span>
                    </label>
                </p>
            </div>


            <div class="form-group row d-flex flex-justify-between">
                <label>{{ $t("Number of main threads") }}:</label>
                <input type="number" v-number v-model.number="restore.source_options.nThreads" class="input w-25" v-range="{ min: 1, max: 20 }">
            </div>
            <div class="form-group pt-4">
                <label>{{ $t("Buffer size") }}:</label>
                <input type="number" v-number v-model.number="restore.source_options.buffer" class="input w-25" v-range="{ min: 150, max: 1500 }">
            </div>

        </div>

        <div v-show="step == STEP_DESTINATION" class="dialog-content overflow">
            <div class="row h6 text-bold m-4">
                <div class="cell-12">{{ $t('Configure destination') }}</div>
            </div>

            <!------------------------------DESTINAZIONE : SCELTA DEL SERVICE ACCOUNT--------------------------------------------------------------->
            <!--Questa pagina deve implementare sendSATestResult-->
            <SARepoSelect :type=restore.type :idSA=restore.destination_idSA :idRepo="-2" @sendSATestResult="sendSATestResult" />
            <!--DESTINAZIONE : SCELTA DEGLI ACCOUNT DA RIPRISTINARE-->
            <SelectedResourcesLayout v-if="destinationData.client != null" :list="destinationData.selectedNodes" :singleItem="false" :canCancel="true" buttonText="Select the mailboxes to restore" :type="restore.type" :heightPercentage="100" @clickFunction="toggleFileSystemSidebar('SELECTMAILBOXES')" />

            <div v-show="destinationData.client != null" class="form-group row pb-5 w-100">
                <label>{{ $t("Custom folder") }}:</label>
                <input data-role="input" class="metro-input" type="text" v-model="restore.destination_customFolder" :placeholder="$t('Enter the name of the customised folder')" v-path="$ONEServiceType.Microsoft_Exchange365" />

            </div>
        </div>


        <!-------------------------------TEST ACCOUNT----------------------------------------->
        <div class="dialog-actions">
            <div v-if="waiting == -1">
                <span class="mif-spinner2 fg-primary ani-spin ml-5" />
            </div>

            <input v-if="step != 1 || restore.source_type != $ONEServiceType.FileFolder" :disabled="step == STEP_SELECTBACKUPCOPY" type="button" v-on:click="setStep(step - 1)" :value="$t('Back')" class="button secondary ml-2" />

            <input type="button" @click="setStep(step + 1)" :value="$t('Next')" class="button secondary ml-2" :disabled="!enableNextButton" />

            <input type="button" @click="startRestore" :value="$t('Start')" class="button secondary ml-2" :disabled="step != STEP_DESTINATION || destinationData.selectedNodes.length == 0 || restore.destination_customFolder == ''" />
        </div>

    </div>
</template>
<script>

import DialogTitle from "../../utils/DialogTitle";
import { isValid } from "../../../utils/utilitiesmodule.js";
import SARepoSelect from "../../utils/SARepoSelect.vue";
import LastResult from "../../utils/LastResult";
import SelectedResourcesLayout from "../../utils/SelectedResourcesLayout";
import { FileSystemSidebarConfig } from "../../../models/TreeNode";
import { draggableMixin } from '../../../mixins/draggable-mixin'
import { getSARootPath, testServiceAccount } from "../../../utils/entityMethods/serviceAccount";

export default {
    mixins: [draggableMixin],
    name: "ExchangeRestore",
    props: {
        restore: {
            type: Object,
            required: true
        }
    },
    components: {
        "DialogTitle": DialogTitle,
        "LastResult": LastResult,
        SARepoSelect,
        SelectedResourcesLayout
    },
    filters: {},

    data() {
        return {
            step: 0,
            STEP_SELECTBACKUPCOPY: 0,
            STEP_SELECTRESTOREOPTIONS: 1,
            STEP_OPTIONS: 2,
            STEP_DESTINATION: 3,

            RESTORETYPE_SELECTSINGLEITEMS: 0,
            RESTORETYPE_BUILDFULLCOPY: 1,
            RESTORETYPE_BUILDSPECIFICCOPY: 2,
            sourceData: {
                serviceAccount: null,
                client: null,
                filteredServiceAccounts: [],
                selectedNodes: [], //appoggio per la copia di backup scelta
            },

            destinationData: {
                serviceAccount: null,
                client: null,
                filteredServiceAccounts: [],
                filteredRepositories: [],
                selectedNodes: [],
                buttonText: null
            },

            waiting: 0,

            fileConfig: null,

            isManual: true,

            str1: "Choose account from credential locker or use Custom credentials",
            microsoftTree: null

        }
    },
    computed: {
        iterationFolder: function () {
            if (this.sourceData.selectedNodes.length == 1)
                return this.sourceData.selectedNodes[0];
            return null;
        },
        enableNextButton: function () {

            switch (this.step) {
                case this.STEP_SELECTBACKUPCOPY:
                    //Nel primo step se il restore è manuale sono obbligato a:
                    // 1 - Selezionare il tipo della sorgente
                    // 2 - Se il tipo della sorgente necessita di un service account, selezionare un serviceaccount e testarlo
                    // 3 - selezionare una cartella di una copia
                    if (
                        this.isManual &&
                        this.restore.source_type != -1 &&
                        (this.restore.source_type == this.$ONEServiceType.FileFolder || this.sourceData.client != null) &&
                        this.iterationFolder != null
                    ) {
                        return true;
                    }

                    //Nel primo step, se il restore è automatico sono obbligato a selezionare un service account e a testarlo se necessario
                    if (
                        !this.isManual &&
                        (this.restore.source_type == this.$ONEServiceType.FileFolder || this.sourceData.client != null)
                    ) {
                        return true;
                    }
                    return false;

                case this.STEP_SELECTRESTOREOPTIONS:

                    return this.restore.restoreType != -1 && this.restore.index != -1;

                case this.STEP_DESTINATION:
                    return false;
            }

            return true;
        },
    },
    created: async function () {
        this.step = 0;
        this.applyExchangeRules();
        this.isManual = !isValid(this.restore.idBackup);
        //Se è un restore automatico da una sorgente filefolder, non mi serve nulla del primo step perchè non ho bisogno del serviceaccount
        this.step = !this.isManual && this.restore.source_type == this.$ONEServiceType.FileFolder
            ? this.STEP_SELECTRESTOREOPTIONS
            : this.STEP_SELECTBACKUPCOPY;

        if (!this.isManual) {
            await this.buildFileConfigFromIDBackup();
        }
    },
    methods: {
        isExchangeRulesActive() {
            return new Date() >= new Date(2026, 9, 1);
        },
        applyExchangeRules() {
            if (!this.isExchangeRulesActive() || !isValid(this.restore.source_options)) {
                return;
            }

            this.restore.source_options.includeArchive = false;
            this.restore.source_options.includePublicFolders = false;
        },
        /************************************STEP 0 : SCELTA DELLA SORGENTE*******************************************************************************/
        setSourceType(type) {
            this.restore.source_type = type;
            this.restore.source_idSA = -2;
            this.sourceData.client = null;
            this.sourceData.serviceAccount = null;
        },

        async sendSATestResult(testResult) {
            let self = this;

            if (self.step == this.STEP_SELECTBACKUPCOPY) {
                self.restore.source_idSA = testResult.serviceAccount.id;
                self.sourceData.serviceAccount = testResult.serviceAccount;
                self.sourceData.client = testResult.client;
                //Finito il test, resetto accountSessionId se il restore è di tipo ftp o network
                //if ([2, $ONEServiceType.Network].includes(self.restore.source_type))
                //    self.sourceData.client.serviceAccount.options.accountSessionId = "";
                return;
            }

            if (self.step == this.STEP_DESTINATION) {
                self.restore.destination_idSA = testResult.serviceAccount.id;
                self.destinationData.serviceAccount = testResult.serviceAccount;
                self.destinationData.client = testResult.client;
                //Finito il test, resetto accountSessionId se la destinazone del restore è di tipo ftp o network
                //if ([2, $ONEServiceType.Network].includes(self.restore.type))
                //    self.destinationData.client.serviceAccount.options.accountSessionId = "";
                //self.toggleFileSystemSidebar();
                return;
            }
        },

        /************************************STEP 1 : SCELTA DELLA MODALITà DI RESTORE*******************************************************************************/

        /**
         * {
         *  id:,
         * currentIndex
         * iterations : // array di : 
         *     {
         *         index:
         *         name:
         *         result:
         *         lastStart
         *         iterationFolder
         *         nCopies
         *         sourceType
         *         destinationType
         *     }
         * }
         * 
         */
        async buildFileConfigFromPath() {
            try {



                this.$root.$emit("closeFileSystemSidebar");
                this.waiting = -1;
                var id_service_account = "";
                if (isValid(this.sourceData.serviceAccount)) id_service_account = this.sourceData.serviceAccount.id;
                try {
                    this.fileConfig = await this.$root.socket("getconfigfileforrestorefile", id_service_account, this.iterationFolder.path);
                    if (isValid(this.fileConfig)) {
                        this.microsoftTree = await this.$root.socket("getTreeFromConfigFile", this.iterationFolder.path, this.restore.type);

                        this.restore.idBackup = this.fileConfig.id;
                        this.restore.backupName = this.fileConfig.iterations[this.fileConfig.currentIndex].name; //assegno il nome del job al momento dell'ultima iterazione eseguita
                        this.setStep(1);
                        this.waiting = 1;
                        return;
                    }
                } catch (ex) {
                    console.writeError(e);
                }
                this.sourceData.selectedNodes.pop();
                this.waiting = 0;

            } catch (e) {

                console.writeError(e);
            }
        },

        async buildFileConfigFromIDBackup() {
            //Step 1 : Prendo i logs del job
            var logs = await this.$api.getBackupLogs(this.restore.idBackup);
            //Step 2 : Ordino i log dal più recente al meno recente
            logs.sort((a, b) => {
                var dateA = this.$moment(a.dt_start_utc.substr(0, 8) + "T" + a.dt_start_utc.substr(8), "YYYYMMDD HH:mm:ss");
                var dateB = this.$moment(b.dt_start_utc.substr(0, 8) + "T" + b.dt_start_utc.substr(8), "YYYYMMDD HH:mm:ss");
                if (dateA > dateB)
                    return -1;
                return 1;
            });
            //Step 3 : Costruisco il file di config prendendo i [nCopies] logs più recenti

            var nCopies = 1; //All'inizio non conosco il numero di copie, quindi lo imposto ad 1 per far partire il for 
            var currentConfiguration;
            var currentIterationFolder;
            var slash;
            for (var c = 0; c < nCopies; c++) {
                if (c >= logs.length)
                    break;
                currentConfiguration = await this.$api.getBackupLogConfiguration(logs[c].id);
                //Al primo log,
                if (c == 0) {
                    //inizio a costruire il fileConfig
                    this.fileConfig = {
                        id: this.restore.idBackup,
                        currentIndex: logs[0].backup_number,
                        nCopies: parseInt(currentConfiguration.sources[0].options.nCopies.toString()),
                        iterations: []
                    };
                    slash = currentConfiguration.destinations[0].path.getSeparator();
                    //imposto il numero di copie
                    nCopies = ["F", "U"].includes(currentConfiguration.sources[0].options.backupType)
                        ? this.fileConfig.nCopies
                        : this.fileConfig.nCopies + 1;
                    //popolo dei dati del restore che prima non conoscevo
                    //this.restore.source.paths.push(new ClientTreeNode(null, null, currentConfiguration.destinations[0].path + slash + this.restore.backupName, getNodeType(currentConfiguration.destinations[0].type, false, false)));

                    //this.sourceData.selectedNodes.push(this.restore.source.paths[0]);
                }

                if (logs[c].backup_number == 0)
                    currentIterationFolder = currentConfiguration.destinations[0].path + slash + this.restore.backupName + slash + "FULL_" + this.restore.idBackup;
                else
                    currentIterationFolder = currentConfiguration.destinations[0].path + slash + this.restore.backupName + slash + logs[c].backup_number.toString().padStart(3, "0") + "_" + this.restore.idBackup;


                if (c == 0) {
                    this.microsoftTree = await this.$root.socket("getTreeFromConfigFile", currentIterationFolder, this.restore.type);
                }

                this.fileConfig.iterations.push({
                    index: logs[c].backup_number,
                    name: this.restore.backupName,
                    result: logs[c].result == 1,
                    lastStart: this.$moment(logs[c].dt_start_utc.substr(0, 8) + "T" + logs[c].dt_start_utc.substr(8), "YYYYMMDD HH:mm:ss"),
                    iterationFolder: currentIterationFolder,
                    nCopies: parseInt(currentConfiguration.sources[0].options.nCopies.toString()),
                    sourceType: currentConfiguration.sources[0].type,
                    destinationType: currentConfiguration.destinations[0].type
                });
            }
        },

        onIterationChanged(iteration) {
            this.restore.index = iteration.index;
            this.restore.source_iterationFolder = iteration.iterationFolder;
            this.restore.backupLastStart = iteration.lastStart;
        },

        /*****************************STEP 2 : SCELTA DEGLI ACCOUNT DA RIPRISTINARE***********************************************************************/
        async startRestore() {
            this.applyExchangeRules();
            this.$root.$emit("closeFileSystemSidebar");
            let self = this;

            this.$root.$on("startRestore_feedback", ok => {
                if (ok.status == self.$ResultValue.OK) {
                    self.startRestore_confirmed();
                }

                this.$root.$off("startRestore_feedback");
            });

            this.$root.$emit("startRestore", this.restore.backupName);
        },

        async startRestore_confirmed() {
            this.$root.$emit("closeFileSystemSidebar");
            let self = this;
            //self.restore.source_iterationFolder = this.iterationFolder.path;
            //se è stata selezionata la root, prendo tutti gli account backuppati in precedenza
            if (this.destinationData.selectedNodes.length == 1 && this.destinationData.selectedNodes[0].resID == '')
                self.restore.destination_accounts = this.destinationData.selectedNodes[0].children.map(m => m.resID).join("|");
            else
                self.restore.destination_accounts = this.destinationData.selectedNodes.map(m => m.resID).join("|");


            var restoreStarted = await self.$root.socket("runexchangerestore", this.restore);

            if (!restoreStarted)
                return;

            this.$root.$emit('CLOSERESTOREDIALOG');

        },

        /*****************************METODI PER LA FILESYSTEMSIDEBAR***********************************************************************/
        async toggleFileSystemSidebar() {

            switch (this.step) {
                case this.STEP_SELECTBACKUPCOPY:
                    this.$root.$emit("closeFileSystemSidebar");
                    this.$root.$emit(
                        "toggleFileSystemSidebar",
                        this.sourceData.selectedNodes,
                        await this._getConfig()
                    );
                    break;

                case this.STEP_DESTINATION:
                    this.$root.$emit("closeFileSystemSidebar");
                    this.$root.$emit(
                        "toggleFileSystemSidebar",
                        this.destinationData.selectedNodes,
                        await this._getConfig()
                    );

            }

        },

        async _getConfig() {

            switch (this.step) {
                case this.STEP_SELECTBACKUPCOPY:
                    //Si deve scegliere la cartella di backup
                    //if (this.restore.source_paths.length == 0 || [1, 2].includes(this.restore.restoreType)) {
                    if (this.restore.source_type == this.$ONEServiceType.Network && this.sourceData.client.serviceAccount.options.accountSessionId == "") {
                        this.sourceData.client.serviceAccount = (await this.testServiceAccount(this.sourceData.client.serviceAccount)).serviceAccount;
                    }
                    return FileSystemSidebarConfig.getForSelectCopyPath(
                        this.restore.source_type,
                        this.sourceData.client,
                        this.getSARootPath(this.sourceData.client.serviceAccount)
                    );

                case this.STEP_DESTINATION:

                    return FileSystemSidebarConfig.get(
                        this.restore.type,
                        false,
                        0,//elementi multipli
                        this.destinationData.client,
                        this.getSARootPath(this.destinationData.client.serviceAccount),
                        this.microsoftTree,
                        false
                    );
            }

            return null;
        },

        /*********************METODI***********************************************/
        setStep(nStep) {
            this.$root.$emit("closeFileSystemSidebar");

            switch (nStep) {
                case this.STEP_SELECTRESTOREOPTIONS:

                    // RESTORE MANUALE + NO FILE CONFIG
                    if (this.isManual && !isValid(this.fileConfig)) {
                        this.buildFileConfigFromPath();
                        return; // lo step verrà impostato solo al momento in cui fileConfig sarà valido
                    }/**/


                    // RESTORE MANUALE + FILE CONFIG + BUILD ITERATION
                    if (this.isManual && isValid(this.fileConfig) && this.restore.restoreType != 0) {
                        this.step = 1; // lo imposto prima, perchè nel seguente metodo verrà considetato lo step corrente
                        return;
                    }

                    // RESTORE AUTOMATICO + FILE CONFIG + BUILD ITERATION
                    if (!this.isManual && isValid(this.fileConfig) && this.restore.restoreType != 0) {
                        this.step = 1;
                        return;
                    }

                    break;
            }

            this.step = nStep;
        }
    }
}
</script>
